export const buildLink = ({
  entityID,
  entityReferenceID,
  entityType,
  policyId
}: {
  entityID?: string
  entityReferenceID?: string
  entityType?: string
  policyId?: string
}): { url: string; text: string; label: string } | undefined => {
  if (
    !entityID ||
    !entityReferenceID ||
    !entityType ||
    !policyId ||
    policyId === entityID
  ) {
    return
  }

  const { directory, label } = ((_entityType) => {
    switch (_entityType) {
      case "Opportunity":
        return {
          directory: "opportunity",
          label: "Opportunity:"
        }
      case "Policy":
        return {
          directory: "policy",
          label: "Policy:"
        }
      default:
        return {
          directory: "",
          label: ""
        }
    }
  })(entityType)

  return {
    url: `/${directory}/${entityID}`,
    text: entityReferenceID || "",
    label
  }
}
